import { ProjectRouteStopSchedulingDtoModelType } from '../../models';
import getAppEnv from '../../utils/getAppEnv';
import { assigningStopMessage } from '../../../../notifications/scheduling/assignStop';

const projectRouteStopSchedulingHandler = ({
  store, pendingSolution,
}: ProjectRouteStopSchedulingDtoModelType) => {
  if (pendingSolution.assignAction.visitId != null) {
    const id = String(pendingSolution.assignAction.visitId);
    const routeName = pendingSolution.assignAction.targetRouteName;
    const { visitName } = pendingSolution.assignAction;

    getAppEnv(store).message(assigningStopMessage(id, visitName, routeName));
  }
};

export default projectRouteStopSchedulingHandler;
